// React imports
import React from 'react';

// UI - style imports
import { WithStyles, withStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';

// local imports
import { styles } from './SpeiNotice.style';

function SpeiNotice(props: WithStyles<typeof styles>) {
    const { classes } = props;

    return (
        <Box className={classes.root}>
            <p>
                <strong>El 11 de febrero de 2026, a las 18:00 horas</strong>, se presentó una{' '}
                <strong>interrupción en la conexión al SPEI</strong>.
            </p>
            <p>
                La contingencia tuvo una duración de <strong>2 horas con 6 minutos</strong>, restableciéndose la
                conexión a las <strong>20:06 horas</strong> y normalizándose la operación a las 20:07 horas del mismo
                día.
            </p>
            <p>
                Durante ese periodo, no fue posible procesar transferencias interbancarias SPEI; no obstante, los
                recursos de los Clientes permanecieron seguros, sin afectación a su integridad ni a la seguridad de la
                información, reanudándose el servicio con normalidad una vez solucionado el incidente.
            </p>
            <p>
                Ni el Gobierno Federal ni las entidades de la administración pública paraestatal podrán
                responsabilizarse o garantizar los recursos de los Clientes que sean utilizados en las Operaciones que
                celebren con las ITF o frente a otros, así como tampoco asumir alguna responsabilidad por las
                obligaciones contraídas por las ITF o por algún Cliente frente a otro, en virtud de las Operaciones que
                celebren.
            </p>
        </Box>
    );
}

export default withStyles(styles)(SpeiNotice);
